/**
 * 工具类-处理window.localStorage存取
 */

/**
 * 存储数据至本地存储
 * @param key 数据 KEY
 * @param data 数据
 * @param type 存储区域，1 session、2 local
 */
export function setStore(key, data, type) {
  // 1 sessionStorage，2 localStorage
  const scope = type || 1;

  data = JSON.stringify(data);

  if (scope === 1) {
    window.sessionStorage.setItem(key, data);
  } else {
    window.localStorage.setItem(key, data);
  }
}


/**
 * 根据数据 KEY 从本地存储获取数据
 * @param key 数据 KEY
 * @returns data 数据
 */
export function getStore(key) {
  let obj = window.sessionStorage.getItem(key);
  if (!obj) {
    obj = window.localStorage.getItem(key);
  }
  return JSON.parse(obj);
}


/**
 * 根据数据 KEY 删除指定存储区域数据
 * @param key 数据 KEY
 * @param type 存储区域，1 session、2 local
 */
export function removeStore(key, type) {
  // 1 sessionStorage，2 localStorage
  const scope = type || 1;
  if (scope === 1) {
    window.sessionStorage.removeItem(key);
  } else {
    window.localStorage.removeItem(key);
  }
}


/**
 * 获取sessionStorage、localStorage所有数据
 * @param type
 * @returns {*[]}
 */
export function getAllStore(type) {
  // 1 sessionStorage，2 localStorage
  const scope = type || 1;
  const dataArray = [];

  if (scope === 1) {
    const sessionStorage = window.sessionStorage;
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      const data = getStore(key);
      dataArray.push({key: key, data: data});
    }
  } else {
    const localStorage = window.localStorage;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const data = getStore(key);
      dataArray.push({key: key, data: data});
    }
  }

  return dataArray;
}


/**
 * 清空指定存储区域所有数据
 * @param type 存储区域，1 session、2 local
 */
export function clearStore(type) {
  // 1 sessionStorage，2 localStorage
  const scope = type || 1;

  if (scope === 1) {
    window.sessionStorage.clear();
  } else {
    window.localStorage.clear();
  }
}


/**
 * 将数据追加至指定数据 KEY 存储区域中
 * @param key 数据 KEY
 * @param data 数据
 * @param type 存储区域，1 session、2 local
 */
export function pushToStoreArray(key, data, type) {
  // 获取数组数据
  let array = getStore(key);
  if (array) {
    array.push(data);
  } else {
    array = [data];
  }
  setStore(key, array, type);
}


/**
 * 验证指定存储 KEY 数据是否存在
 * @param key 数据 KEY
 * @returns true 存在，false 不存在
 */
export function dataIsExists(key) {
  const obj = getStore(key);
  return obj !== undefined && obj != null && obj !== '';
}
